module.exports = __webpack_public_path__ + "d103ecd4ef89a9441578d0412c3df0.png";